export const formatPrice = (price: number = 0, currency: string = 'GBP') =>
  Number(price).toLocaleString(undefined, { style: 'currency', currency });

export const formatDiscount = (discount: number = 0) =>
  discount && Number(discount) > 0
    ? Number(discount / 100).toLocaleString(undefined, {
        style: 'percent',
        maximumFractionDigits: 2,
      })
    : 0;
